import { useEffect, useState } from "react";
import { Card,CardBody, CardHeader } from "react-bootstrap";
import './PurchaseSummary.css'

const PurchaseSummary = (address)=>{
    const [selAddresses,setSelAddresses] = useState([]);
    useEffect(()=>{
        console.log(selAddresses,address)
        let temp = JSON.parse(localStorage.getItem('address-selection'))
        setSelAddresses([...temp])
    },[])
    return(<>
    <div>
    <div className='row order-container'>
        <div className='pointer col-md-3 first-pointer' style={{ marginLeft: "1em" }}>ENTER ADDRESS<span>1</span></div>
        <div className='pointer col-md-3 sec-pointer' style={{ background: "#BAE5EC" }}>ADD INSTRUCTIONS<span>2</span></div>
        <div className='pointer col-md-3 last-pointer'>CONFIRM ORDER<span>3</span></div>
    </div>
</div>
<div className="my-4 purchase-cont" style={{ padding: '0px 3rem' }}>
                <div className="row" style={{ height: "100%" }}>
                    <div className="col-md-9" >
    <Card style={{ padding: '0px', marginRight: '0.5em', marginBottom: '1rem' }}>
        <CardHeader style={{background:"lightblue",fontFamily:"Calibri Bold",fontSize:"20"}}>
            <b>Order Details</b>
        </CardHeader>
    </Card>
</div>
<Card className="col-md-3" style={{height:"65vh"}}>
        <p className="summary-title"><b>SUMMARY</b></p>
</Card>
</div></div>
</>)
}
export default PurchaseSummary;